export const doc_purchases_en = {
  title: "Purchases",
  description_1: `As a free Piper user, you have the following limitations on each of these resources:
`,
  limit_albums: "300 albums",
  limit_collections: "3 collections",
  limit_shelvings: "2 shelving units",
  limit_artists: "200 artists",
  limit_labels: "200 labels",
  limit_album_formats: "10 album formats",
  limit_album_types: "10 album types",
  limit_tags: "30 tags",
  limit_stores: "50 stores",
  limit_sell_values: "50 sale prices",
  limit_exchange_rates: "100 exchange rates",
  description_2: `
When you reach any of these limits, the system will notify you that you have reached the maximum for that resource when you want to add a new item. You always have the option to delete an item to add a different one at any time.

If you want to extend any of these limits, you can make a purchase. Each resource has different packages that, when purchased, will extend the limit by a certain amount. You can find the purchase menu for each resource in your user profile, in the table that indicates your current limits.

The new limit is credited immediately once the payment is successful.

To use Apple Pay, you must use the native iOS app available on the App Store. The amount may differ between payment methods.

If you have any problems with a purchase, please do not hesitate to contact support so we can correct your situation as soon as possible.
  
`
};
